export default __webpack_public_path__ + "static/media/avatar.6cfd1ed1.png";